import React from "react";
import Header from "../component/Header";
import { Outlet } from "react-router-dom";

export default function Expenses() {
  const navbarMenu = [
    { name: "Expenses", pageNavigate: "expensesView" },
    { name: "Add Expenses", pageNavigate: "expensesAdd" },
  ];
  return (
    <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  );
}
